query MailerConfigsAutocomplete(
  $input: String = ""
  $value: [ID!] = []
  $filter: MailerConfigsFilterInput
) {
  autocomplete: autocompleteMailerConfigs(
    input: $input
    value: $value
    filter: $filter
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
